import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const determineColor = ({ dotColor, theme }) => {
  if (dotColor) {
    if (theme.colors[dotColor]) {
      return theme.colors[dotColor];
    }

    return dotColor;
  }

  return theme.colors.default;
};

const DotButton = styled.button.attrs(props => ({
  'aria-label': props['aria-label'] || `Go to slide ${props.index + 1}`,
}))`
  position: relative;
  width: 18px;
  height: 24px;
  background: transparent;
  color: transparent;

  &:before {
    content: '';

    position: absolute;
    bottom: 7px;
    left: 4px;

    display: block;
    box-sizing: border-box;
    width: 10px;
    height: 10px;

    border: 1px solid ${determineColor};
    border-radius: 100%;
  }

  &:focus {
    outline: none;
    border-radius: 100%;

    &:before {
      box-shadow: 0 0 0 2px ${determineColor};
    }
  }
`;

const CarouselDotButton = props => {
  return <DotButton {...props} />;
};

CarouselDotButton.propTypes = {
  dotColor: PropTypes.string,
};

CarouselDotButton.defaultProps = {
  dotColor: 'default',
};

CarouselDotButton.DotButton = DotButton;

export default CarouselDotButton;
